module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit_comment_label":"Modify Comments","delete_comment_label":"Delete Comments","delete_comment_confirmation":"Are you sure you want to delete the comments?"}}')
  delete Component.options._Ctor
}
